import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';

import { CommunicationService } from '../services/communication.service';
import { HttpResponse } from '@angular/common/http';
import { ConcessionData } from '../domains/common.domain';
import { map } from 'rxjs/operators';

@Injectable()
export class LicenseService {
  constructor(private communicationService: CommunicationService) {}

  downloadLicense(): Observable<HttpResponse<Blob>> {
    return this.communicationService.getData('concession?download=1', { responseType: 'blob' as 'json', observe: 'response' });
  }

  getConcession(): Observable<ConcessionData> {
    return this.communicationService
      .getData<{ concession: ConcessionData[] }>('concession')
      .pipe(map(response => response.concession?.find(() => true)));
  }

  updateLicense(): Observable<any> {
    return this.communicationService.updateData('concession?renew=1', {});
  }
}
